import apiClient from './api';

export const getConversations = async () => {
    return apiClient.get('/messages');
};

export const getMessages = async (userId) => {
    return apiClient.get(`/messages/${userId}`);
};

export const sendMessage = async (formData) => {
    // formData should contain 'recipientId', 'content' (optional), and 'file' (optional)
    // We used multer, so we must send multipart/form-data
    // apiClient handles Content-Type automatically if we pass FormData, 
    // but explicitly setting it to undefined lets browser set boundary.
    return apiClient.post('/messages', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
